import {IdleQueue} from './IdleQueue'

const queue = new IdleQueue({ensureTasksRun: true})

export const runInIdleTime = (callback: () => void) => {
  queue.pushTask(callback)
}
